import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {AssignProductSeatResultModal} from './assign-product-seat.result.modal';
import {clearResult, selectAssignProductSeatShown, selectAssignProductSeatTask, selectAssignProductSeatUuid} from './assign-product-seat.slice';

export const AssignProductSeatResult = () => (
    <BulkActionResult
        actionIdSelector={selectAssignProductSeatUuid}
        actionTaskSelector={selectAssignProductSeatTask}
        actionShownSelector={selectAssignProductSeatShown}
        clearResult={clearResult}>
        {({id, onClose}) => <AssignProductSeatResultModal id={id} onClose={onClose}/>}
    </BulkActionResult>
);
